import EditorJS from '@editorjs/editorjs'; 
import Header from '@editorjs/header'; 
import List from '@editorjs/list'; 
import SimpleImage from '@editorjs/simple-image';
import RawTool from '@editorjs/raw';
import Checklist from '@editorjs/checklist';
import Quote from '@editorjs/quote';
import Embed from '@editorjs/embed';
import { RichEditor } from './edit-base';

function bindEditorInstance(element, options){
    var defaults = {
        holder: element,
        tools: { 
          header: Header, 
          list: List,
          image: SimpleImage,
          raw: RawTool,
          checklist: Checklist,
          quote: Quote,
          embed: {
            class: Embed,
            config: {
              services: {
                youtube: true,
                coub: true
              }
            }
          },
        },
    };
    return new EditorJS(Object.assign(defaults, options));
}

export class RichEditorJS extends RichEditor {
	constructor(el){
        super(el);
        this.element.style.display ='none';
        this.editorEl = document.createElement('div');
        this.editorEl.classList.add('html-editor', 'editor-editorjs');
        this.element.insertAdjacentElement('afterend',this.editorEl);
	}
    setEditorContent(raw_src) {        
        this.editor = bindEditorInstance(this.editorEl, {
            onReady: () => {this.onEditorReady(raw_src)}
        });
        
    }
    onEditorReady(raw_src){
        // First check if src is JSON. If not, it is probably HTML
        try {
            var data = JSON.parse(raw_src);
            this.editor.render(data);
        } catch (error) {
            // Fallback to parsing HTML
            this.editor.blocks.renderFromHTML(raw_src);
        }
        
        // Bind change event to editor so that we can update the data we expose
        this.editor.on('change', () => {
            this.editor.save().then((outputData) => {
                this._src = JSON.stringify(outputData);
            });
        })
    }
    getData(){
        return this._src;
    }
    getHTML(){
        // HTML Parsing is done on the server side
        return ''; 
    }
    removeEditor(){
        this.editor.destroy();
    }
}
